<template>
    <div class="last main-flex" :style="{background:'url('+ bg + ') no-repeat center',backgroundSize:'100% 100%'}">
        <!-- 资质荣誉 手机端<992px隐藏 -->
        <div class="honor hidden-sm-and-down">
            <YYTitle :yyMsg="yyM1" style="padding-top: 30px;"></YYTitle>
            <div class="yyCas block">
                <!-- 大屏 ≥992px 每页6张 -->
                <el-carousel class="hidden-md-and-down" trigger="click" arrow="always">
                    <el-carousel-item v-for="item in Math.ceil(imgList.length/6)" :key="item">
                        <el-row type="flex">
                            <el-col :span="4">
                                <!-- 替换el-image为加密背景容器，移除预览 -->
                                <div class="img-box" :data-img-index="(item-1)*6"></div>
                            </el-col>
                            <el-col :span="4" v-show="imgList[(item-1)*6+1]">
                                <div class="img-box" :data-img-index="(item-1)*6+1"></div>
                            </el-col>
                            <el-col :span="4" v-show="imgList[(item-1)*6+2]">
                                <div class="img-box" :data-img-index="(item-1)*6+2"></div>
                            </el-col>
                            <el-col :span="4" v-show="imgList[(item-1)*6+3]">
                                <div class="img-box" :data-img-index="(item-1)*6+3"></div>
                            </el-col>
                            <el-col :span="4" v-show="imgList[(item-1)*6+4]">
                                <div class="img-box" :data-img-index="(item-1)*6+4"></div>
                            </el-col>
                        </el-row>
                    </el-carousel-item>
                </el-carousel>
                
                <!-- 中屏768~991px 每页3张 -->
                <el-carousel class="hidden-sm-and-down hidden-lg-and-up" trigger="click" arrow="always">
                    <el-carousel-item v-for="item in Math.ceil(imgList.length/3)" :key="item">
                        <el-row type="flex">
                            <el-col :span="8">
                                <div class="img-box" :data-img-index="(item-1)*3"></div>
                            </el-col>
                            <el-col :span="8" v-show="imgList[(item-1)*3+1]">
                                <div class="img-box" :data-img-index="(item-1)*3+1"></div>
                            </el-col>
                            <el-col :span="8" v-show="imgList[(item-1)*3+2]">
                                <div class="img-box" :data-img-index="(item-1)*3+2"></div>
                            </el-col>
                        </el-row>
                    </el-carousel-item>
                </el-carousel>
            
            </div>
        </div>
    </div>
</template>

<script>
import YYTitle from '../yyTitle.vue'
import XSTitle from '../eyTitXs.vue'

export default {
    props:{
        bg: String
    },
    components:{
        YYTitle,
        XSTitle
    },
    data(){
        return{
            yyM1: '资质荣誉',
            yyM2: '合作院校',
            titEN2: 'COOPERATIVE COLLEGES',
            pList:['滨州医学院','山东第一医科大学','上海健康医学院','四川大学','华中科技大学','南开大学','郑州大学','徐州医科大学','南京医科大学',
                    '西南医科大学','新疆医科大学','杭州医学院'],
            bgPst:[],
            sprite: require('@/assets/school.png'),
            imgList:[],
            srcList:[],
            // 保存监听函数，用于卸载移除
            contextMenuHandler: null,
            dragHandler: null,
            copyHandler: null,
            cutHandler: null,
            pasteHandler: null,
            keyDownHandler: null
        }
    },
    created(){
        // 精灵图逻辑不变
        for(let k=0;k<36;k++){
            this.bgPst[k] = {x:0,y:0}
        }
        for(let i=0;i<9;i++){
            for(let j=0;j<4;j++){
                this.bgPst[i+9*j].x = -368-136*i+'px'
                this.bgPst[i+9*j].y = -150-186*j+'px'
            }
        }

        // 资质荣誉图片数组
        let a = new Array(14)
        let b = new Array(14)
        for(let n=1;n<a.length+1;n++){
            a[n-1] = require('@/assets/honor/'+ n +'.png')
            b[n-1] = require('@/assets/honor/qingxi/'+ n +'.jpg')
        }
        this.imgList = a
        this.srcList = b
    },
    mounted() {
        // 赋值具名处理函数
        this.contextMenuHandler = (e) => e.preventDefault()
        this.dragHandler = (e) => e.preventDefault()
        this.copyHandler = (e) => e.preventDefault()
        this.cutHandler = (e) => e.preventDefault()
        this.pasteHandler = (e) => e.preventDefault()
        
        this.keyDownHandler = (e) => {
            // ====== 删除F12拦截，F12可正常使用 ======
            // Ctrl+U 查看源码
            if (e.ctrlKey && e.key.toLowerCase() === 'u') e.preventDefault()
            // Ctrl+Shift+I / Ctrl+Shift+C / Ctrl+Shift+J 打开调试面板快捷键屏蔽
            if (e.ctrlKey && e.shiftKey && ['i','c','j'].includes(e.key.toLowerCase())) e.preventDefault()
            // Ctrl+S 保存页面
            if (e.ctrlKey && e.key.toLowerCase() === 's') e.preventDefault()
            // Ctrl+P 打印（可截图保存图片）
            if (e.ctrlKey && e.key.toLowerCase() === 'p') e.preventDefault()
        }

        // 绑定全局事件
        document.addEventListener('contextmenu', this.contextMenuHandler)
        document.addEventListener('dragstart', this.dragHandler)
        document.addEventListener('copy', this.copyHandler)
        document.addEventListener('cut', this.copyHandler)
        document.addEventListener('paste', this.pasteHandler)
        document.addEventListener('keydown', this.keyDownHandler)

        // Canvas绘制图片
        this.renderImgBg()
    },
    beforeUnmount() {
        // 销毁组件解绑全局监听，避免事件叠加
        document.removeEventListener('contextmenu', this.contextMenuHandler)
        document.removeEventListener('dragstart', this.dragHandler)
        document.removeEventListener('copy', this.copyHandler)
        document.removeEventListener('cut', this.cutHandler)
        document.removeEventListener('paste', this.pasteHandler)
        document.removeEventListener('keydown', this.keyDownHandler)
    },
    methods:{
        renderImgBg() {
            this.$nextTick(async () => {
                const boxes = document.querySelectorAll('.img-box')
                boxes.forEach(box => {
                    const idx = Number(box.dataset.imgIndex)
                    const originUrl = this.imgList[idx]
                    const waterUrl = this.srcList[idx]
                    if (!originUrl) return

                    box.style.backgroundImage = ''
                    box.innerHTML = ''

                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d')
                    const originImg = new Image()
                    originImg.crossOrigin = 'anonymous'
                    originImg.src = originUrl

                    originImg.onload = () => {
                        canvas.width = originImg.width
                        canvas.height = originImg.height
                        ctx.drawImage(originImg, 0, 0)

                        if (waterUrl) {
                            const waterImg = new Image()
                            waterImg.crossOrigin = 'anonymous'
                            waterImg.src = waterUrl
                            waterImg.onload = () => {
                                ctx.globalAlpha = 0.08
                                ctx.drawImage(waterImg, 0, 0, canvas.width, canvas.height)
                                ctx.globalAlpha = 1
                            }
                        }
                        box.appendChild(canvas)
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.main-flex{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
}

.last{
    width: 100%;
    margin: auto;
    // 顶部外边距弹性自适应：最小60px，最大120px，中间10vh随屏幕高度缩放
    margin-top: clamp(60px, 10vh, 120px);
    .honor{
        width: 95%;
        margin: 0 auto;
        .yyCas{
            width: 100%;
            // 上下内边距弹性缩放，替代vw(50)/vw(194)
            padding: 80px 0px;

            // 图片容器自适应
            .img-box {
                width: 85%;
                // 高度随屏幕宽度等比例变化，最小80px，最大160px
                height: clamp(80px, 12vw, 160px);
                margin: 0 auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                pointer-events: none; /* 完全禁止点击交互 */
                user-select: none; /* 禁止选中图片 */
                -webkit-user-select: none;
                position: relative;
            }
            // Canvas铺满容器，视觉和原background-size:contain完全一致
            .img-box canvas {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }

            ::v-deep {
                .el-row{
                    justify-content: center;
                    flex-wrap: wrap;
                }

                .el-carousel__arrow{
                    transform: none;
                    &--left,
                    &--right{
                        // 箭头垂直居中偏移，替代vw(95)
                        top: clamp(60px, 9vw, 95px);
                    }
                    &--left{
                        left: 0;
                    }
                    &--right{
                        right: 0;
                    }
                }

                .el-carousel__button{
                    // 圆点大小自适应，替代vw(9)
                    width: clamp(6px, 0.8vw, 9px);
                    height: clamp(6px, 0.8vw, 9px);
                    // 圆点间距自适应，替代vw(15)
                    margin-right: clamp(10px, 1.3vw, 15px);
                    background-color: $gray80;
                    border-radius: 50%;
                }

                .el-carousel__indicator{
                    opacity: none;
                    &:hover,
                    &.is-active{
                        button{
                            background-color: $yyBlue;
                        }
                    }
                    @media screen and (max-width: 992px){
                        display: none;
                    }
                }
            }
        }

        ::v-deep {
            .cusTitle{
                position: relative; 
                // 标题字号自适应，替代vw(30)
                font-size: clamp(18px, 2.5vw, 30px);
                color: $fontGray;
                font-weight: 500;
            
                &:after{
                    content: 'HONOR';
                    color: $yyBlue;
                    // 英文大字自适应，替代vw(72)
                    font-size: clamp(40px, 6vw, 72px);
                    // 垂直负边距自适应，替代vw(-95)
                    top: clamp(-60px, -9vw, -95px);
                    left: 50%;
                    transform: translateX(-50%);
                    font-weight: 800;
                }
            }
        }
    }

    .co{
        .bTitle{
            // 底部内边距自适应，替代vw(47)
            padding-bottom: clamp(25px, 4vw, 47px);
        }
        .iconList{
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            // 左右间距自适应，替代vw(8)
            padding: 0 clamp(5px, 0.7vw, 8px);
            // 底部外边距自适应，替代vw(24)
            margin-bottom: clamp(12px, 2vw, 24px);
            .icon{
                width: clamp(60px, 8vw, 96px);
                height: clamp(60px, 8vw, 96px);
                // 底部间距自适应，替代vw(14)
                margin-bottom: clamp(8px, 1.2vw, 14px);
                zoom: 0.7;
            }
            p{
                // 文字自适应，替代vw(14)
                font-size: clamp(10px, 1.2vw, 14px);
                margin: 0;
                color: $font23;
            }
        }
        ::v-deep {
            .el-row{
                display: flex;
                flex-wrap: wrap;
            }
            .cusTitle{
                font-size: clamp(18px, 2.5vw, 30px);
                color: $fontGray;
                font-weight: 500;
                &:after{
                    content: 'COOPERATE';
                    color: $yyBlue;
                    font-size: clamp(40px, 6vw, 72px);
                    // 垂直偏移自适应，替代vw(-86)
                    top: clamp(-55px, -8vw, -86px);
                    // 左侧偏移自适应，替代vw(345)
                    left: clamp(180px, 30vw, 345px);
                    font-weight: 800;
                }
            }
        }
    }

    // 手机端 <767px 适配
    @media only screen and (max-width: 767px){
        // 上下内边距弹性px替代vp单位
        padding-top: 30px;
        padding-bottom: 35px;
        .co{
            .iconList{
                margin-bottom: 24px;
                .icon{
                    zoom: .5;
                }
            }
        }
    }
}
</style>